/* Copyright (c) Trimble Inc. All rights reserved. */

import { getCurrentLocation, Logger } from '@tcp-base/toolkit';

/**
 * Generate a random state parameter for OAuth2
 */
export function generateOAuthState(): string {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

/**
 * Check if URL contains a specific query parameter
 */
export function hasQueryParam(paramName: string): boolean {
  try {
    const location = getCurrentLocation();
    const urlParams = new URLSearchParams(location.search);
    return urlParams.has(paramName);
  } catch (error) {
    Logger.warn('Failed to check query parameter:', error);
    return false;
  }
}

/**
 * Get a specific query parameter value
 */
export function getQueryParam(paramName: string): string | null {
  try {
    const location = getCurrentLocation();
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get(paramName);
  } catch (error) {
    Logger.warn('Failed to get query parameter:', error);
    return null;
  }
}

/**
 * Check if we're in the middle of an OAuth2 callback (code parameter present)
 */
export function isOAuthCallback(): boolean {
  return hasQueryParam('code');
}
